import React from "react";
import PropTypes from "prop-types";
import RadioGroup from "components/RadioGroup/index";
// import { DropdownNewCustom } from "components/Dropdown/index";
// import { AnnualIncomeSlider } from "components/AnnualIncomeSlider/index";
// import { LiquidNetWorthSlider } from "components/LiquidNetWorthSlider/index";
import { ChoiceWrapper } from "../../Components/SignupContainer.styles";
import { QuestionContent } from "../IntroQuestions.styles";
import {
  // EMPLOYMENT_STATUS_OPTIONS,
  // ANNUAL_INCOME_OPTIONS,
  FUNDING_SOURCE_OPTIONS,
  // LIQUID_NET_WORTH_OPTIONS,
  AFFILIATION_OPTIONS,
} from "../constants";

const KycQuestions = ({
  // employmentStatus,
  // setEmploymentStatus,
  // annualIncome,
  // setAnnualIncome,
  fundingSource,
  setFundingSource,
  // liquidNetWorth,
  // setLiquidNetWorth,
  affiliations,
  setAffiliations,
}) => {
  return (
    <>
      <div className="header">
        <h3>Next, let&apos;s understand more about your investing habits</h3>
        <p>
          By answering the following questions, we can provide a tailored
          experience to help you succeed with your Surmount accounts!
        </p>
      </div>

      {/* Employment Status */}
      {/* <QuestionContent
        $isAnswered={!!employmentStatus}
        $isCurrentOrPrevious={true}
        $isInteractive={true}
      >
        <ChoiceWrapper>
          <DropdownNewCustom
            title="What is your current employment status?"
            options={EMPLOYMENT_STATUS_OPTIONS}
            value={employmentStatus}
            onChange={setEmploymentStatus}
            name="employment-status"
            disabled={false}
          />
        </ChoiceWrapper>
      </QuestionContent> */}

      {/* Annual Income */}
      {/* <QuestionContent
        $isAnswered={!!annualIncome}
        $isCurrentOrPrevious={true}
        $isInteractive={true}
      >
        <ChoiceWrapper>
          <AnnualIncomeSlider
            title="What is your annual income?"
            value={annualIncome}
            onChange={setAnnualIncome}
            name="annual-income"
            disabled={false}
            options={ANNUAL_INCOME_OPTIONS}
          />
        </ChoiceWrapper>
      </QuestionContent> */}

      {/* Funding Source */}
      <QuestionContent
        $isAnswered={!!fundingSource}
        $isCurrentOrPrevious={true}
        $isInteractive={true}
      >
        <ChoiceWrapper>
          <RadioGroup
            title="What will be your primary source of funding for this investment?"
            options={FUNDING_SOURCE_OPTIONS}
            value={fundingSource}
            onChange={setFundingSource}
            name="funding-source"
            disabled={false}
            placeholder="Select an option"
          />
        </ChoiceWrapper>
      </QuestionContent>

      {/* Liquid Net Worth */}
      {/* <QuestionContent
        $isAnswered={!!liquidNetWorth}
        $isCurrentOrPrevious={true}
        $isInteractive={true}
      >
        <ChoiceWrapper>
          <LiquidNetWorthSlider
            title="What is your liquid net worth?"
            value={liquidNetWorth}
            onChange={setLiquidNetWorth}
            name="liquid-net-worth"
            disabled={false}
            options={LIQUID_NET_WORTH_OPTIONS}
          />
        </ChoiceWrapper>
      </QuestionContent> */}

      {/* Affiliation */}
      <QuestionContent
        $isAnswered={true}
        $isCurrentOrPrevious={true}
        $isInteractive={true}
      >
        <ChoiceWrapper>
          <RadioGroup
            title="To comply with regulations, please select the one that applies"
            options={AFFILIATION_OPTIONS}
            value={affiliations}
            onChange={setAffiliations}
            name="affiliations"
            disabled={false}
          />
        </ChoiceWrapper>
      </QuestionContent>
    </>
  );
};

KycQuestions.propTypes = {
  employmentStatus: PropTypes.string.isRequired,
  setEmploymentStatus: PropTypes.func.isRequired,
  annualIncome: PropTypes.string.isRequired,
  setAnnualIncome: PropTypes.func.isRequired,
  fundingSource: PropTypes.string.isRequired,
  setFundingSource: PropTypes.func.isRequired,
  liquidNetWorth: PropTypes.string.isRequired,
  setLiquidNetWorth: PropTypes.func.isRequired,
  affiliations: PropTypes.array.isRequired,
  setAffiliations: PropTypes.func.isRequired,
};

export default KycQuestions;
